import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'
import { Wallet } from '@factorialco/f0-react/icons/app'

import Upgrade from 'modules/core/components/Upgrade'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import ApprovalsBlock from 'modules/approvals/components/ApprovalsConfigurationBlock'
import { useApprovalFeatures } from 'modules/approvals/hooks/useFeatureLimits'
import UpgradePlanModal from 'modules/expenses/components/UpgradePlanModal'
import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'
import { missingFeatureRequestReason } from 'modules/finance/lib/missingFeatureRequestReason'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface Props {
  canEditApprovers: boolean
}

const ExpensesApprovalWorkflow = ({ canEditApprovers }: Props) => {
  const [showUpgradeModal, setShowUpgradeModal] = useState(false)
  const [showUpgradeModalFlow, setShowUpgradeModalFlow] = useState(false)
  const { canAddGroup } = useApprovalFeatures('expenses')
  const { company } = useCurrentSession()

  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo
        icon={Wallet}
        title={i18n.t('expenses_v2.settings.expense_policy.approval_workflows')}
      />

      {canEditApprovers && (
        <ApprovalsBlock
          category="expenses"
          title={i18n.t('expenses.settings.approvals.title')}
          description={i18n.t('expenses.settings.approvals.description')}
          noPadding
          multigroup
          onAddGroup={
            !canAddGroup()
              ? () => {
                  setShowUpgradeModal(true)
                }
              : undefined
          }
          icon={'document-approved'}
          hideAddGroupButton={!canAddGroup()}
          addGroupButtonFallback={
            <Upgrade.Small
              title={i18n.t('settings.approvals.upgrade')}
              action={{
                type: 'know_more',
                onClick: () => setShowUpgradeModalFlow(true),
              }}
            />
          }
        />
      )}

      {showUpgradeModal && (
        <UpgradePlanModal
          origin="createPolicy"
          onClose={() => {
            setShowUpgradeModal(false)
          }}
        />
      )}
      {showUpgradeModalFlow && (
        <UpsellingKit.ProductModal
          isOpen={showUpgradeModalFlow}
          onClose={() => setShowUpgradeModalFlow(false)}
          requestSource="Expenses settings page"
          featureRequested={Features.expenses_approval_policies}
          moduleRequested={AvailableModules.expenses}
          requestReason={missingFeatureRequestReason(company)}
          pageSource="expenses_settings"
        />
      )}
    </Box>
  )
}

export default ExpensesApprovalWorkflow
